import React, {Component} from "react";
import { database, authentication } from "../../app-database";
import firebase from "firebase";
import { getClientInfo } from "../../movil/polizas/pagoPorKilometro.act";

const cameraPlaceholder1 = require("../../img/auto1.png");
const cameraPlaceholder2 = require("../../img/auto2.png");
const cameraPlaceholder3 = require("../../img/auto3.png");
const cameraPlaceholder4 = require("../../img/auto4.png");
const cameraPlaceholder = require("../../img/camera.png");

const procedencia = ["Antiguos", "Blindados", "Clásicos", "Fronterizos",
	"Importados", "Legalizados","Residentes"];
const uso = ["Particular"];
const tipo = ["AUT", "CA1", "CA2", "AUF", "C1F", "C2F", "MOT"];
const anios=[];
const anioActual = new Date().getFullYear()+1;
const anioInicio = 2010;
for(let i = anioInicio;i<anioActual;i++){
	anios.push(i);
}
const tipoPersona = ["Fisica", "Moral"];

class AdminKM0 extends Component{
	constructor(props){
		super(props);
		this.state={
			show:false,
			buscar: "",
			version: 0,
			tab: "tabConfiguracion",						
			result:{
				candidate:true,
				startKm: 0,
				startPhoto: cameraPlaceholder,
				vin: cameraPlaceholder,
				supDer: cameraPlaceholder2,
				supIzq: cameraPlaceholder1,
				infDer: cameraPlaceholder3,
				infIzq: cameraPlaceholder4,
			},
			config: {				
				modelo:anioInicio,
				negocioOperable: "",
				procedencia: ["Residentes"],
				productoComercial: "",
				productoTecnico:"",
				productos:[this.getEmptyProduct()],
				tipo: ["AUT"],
				tipoPersona:["Fisica"],
				uso:"Particular",				
			}
		};
	}

	render(){
		const {config,show, tab, buscar, version, result} = this.state;
		return (
			<div class="container">
				<h1 style={{marginLeft:10}}>Administrador Kilómetro 0</h1>
				<br/>
				{!show && <div className="aceptar-cancelar-btn"><a className="orange-btn" onClick={this.login.bind(this)}>Modificar</a></div>}
				{show &&(
					<div>
						<div className="blue-wrap text-center">						
							<div className="container">
								<ul className="blue-menu clearfix">
									<li>
										<a className={tab=="tabConfiguracion"?"active":""} onClick={this.selectTab.bind(this, ["tabConfiguracion"])}>Configuración</a>
									</li>
									<li>
										<a className={tab=="tabBuscar"?"active":""} onClick={this.selectTab.bind(this, ["tabBuscar"])}>Buscar</a>
									</li>
								</ul>
							</div>
						</div>
						{tab == "tabConfiguracion" &&
							<div>
								<div className="card" style={{maxWidth:400, margin: "0 auto"}}>
									<div className="input-wrap no-margin">
										<label>Procedencia</label>
										<span className="clearfix input-active">
											<select value={config.procedencia} className="col-xs-1" multiple style={{height:"100%"}} onChange={this.onChangeMultiple.bind(this, "procedencia")}>
												{procedencia.map((p,i)=><option key={i} value={p}>{p}</option>)}
											</select>
										</span>
									</div>
									<div className="input-wrap no-margin">
										<label>Uso</label>
										<span className="clearfix input-active">
											<select value={config.uso} className="col-xs-1" disabled>
												{uso.map((p,i)=><option key={i} value={p}>{p}</option>)}
											</select>
										</span>
									</div>
									<div className="input-wrap no-margin">
										<label>Tipo de Vehículo</label>
										<span className="clearfix input-active">
											<select  value={config.tipo} className="col-xs-1" multiple style={{height:"100%"}} onChange={this.onChangeMultiple.bind(this, "tipo")}>
												{tipo.map((p,i)=><option key={i} value={p}>{p}</option>)}
											</select>
										</span>
									</div>
									<div className="input-wrap no-margin">
										<label>Año de Modelo</label>
										<span className="clearfix input-active">
											<select value={config.modelo} className="col-xs-1" onChange={this.onChange.bind(this, "modelo")}>
												{anios.map((p,i)=><option key={i} value={p}>{p}</option>)}
											</select>
										</span>
									</div>
									<div className="input-wrap no-margin">
										<label>Tipo Persona</label>
										<span className="clearfix input-active">
											<select value={config.tipoPersona} className="col-xs-1" multiple style={{height:"100%"}} onChange={this.onChangeMultiple.bind(this, "tipoPersona")}>
												{tipoPersona.map((p,i)=><option key={i} value={p}>{p}</option>)}
											</select>
										</span>
									</div>
								</div>
								{config.productos.map((p,i)=>(
									<div className="card" style={{maxWidth:400, margin: "20px auto"}}>
										<div className="input-wrap no-margin">
											<label>Producto Técnico</label>
											<span className="clearfix input-active">
												<input value={p.productoTecnico} className="col-xs-1" onChange={this.onChangeIndex.bind(this, i, "productoTecnico")}>
													
												</input>
											</span>
										</div>
										<div className="input-wrap no-margin">
											<label>Producto Comercial</label>
											<span className="clearfix input-active">
												<input value={p.productoComercial}  className="col-xs-1" onChange={this.onChangeIndex.bind(this, i, "productoComercial")}>
													
												</input>
											</span>
										</div>
										<div className="input-wrap no-margin">
											<label>Id Negocio Operable</label>
											<span className="clearfix input-active">
												<input value={p.negocioOperable}  className="col-xs-1" onChange={this.onChangeIndex.bind(this, i, "negocioOperable")}>
													
												</input>
											</span>
										</div>
										<br/>	
										{i>0 &&							
										<a className="orange-btn"onClick={this.remove.bind(this,i)}>Eliminar</a>}
									</div>
								))}
								<div className="aceptar-cancelar-btn">
									<a className="orange-btn"onClick={this.add.bind(this)}>Agregar</a>
									<a className="orange-btn"onClick={this.save.bind(this)}>Guardar</a>
								</div>
							</div>
						})
						{tab == "tabBuscar" && (
							<div>
								<div className="card" style={{maxWidth:400, margin: "0 auto"}}>
									<div className="input-wrap no-margin">
										<label>* Póliza</label>
										<span className="clearfix input-active">
											<input type="text" value={buscar} required className="col-xs-2" min="0" onChange={this.onChangeBuscar.bind(this, "buscar")}>
													
											</input>
											
										</span>
									</div>
									<div className="input-wrap no-margin">
										<label>* Versión</label>
										<span className="clearfix input-active">
											<input type="text" value={version} className="col-xs-2" min="0" onChange={this.onChangeBuscar.bind(this, "version")}>
													
											</input>
											
										</span>
									</div>
								</div>
								<div className="aceptar-cancelar-btn text-center">
									<a className="orange-btn"onClick={this.search.bind(this)}>Buscar</a>									
								</div>
								{!result.candidate && (
									<div className="text-center">
										{result.razon}
									</div>
								)}
								{result.datos && (
									<div className="row card" style={{ maxWidth:400,  margin: "20px auto"}}>
										<div className="input-wrap no-margin">
											<label>Producto Técnico</label>
											<span className="clearfix input-active">
												<input value={result.datos.productoTecnico} disabled  className="col-xs-1" >
													
												</input>
											</span>
										</div>
										<div className="input-wrap no-margin">
											<label>Producto Comercial</label>
											<span className="clearfix input-active">
												<input value={result.datos.productoComercial} disabled  className="col-xs-1" >
													
												</input>
											</span>
										</div>
										<div className="input-wrap no-margin">
											<label>Id Negocio Operable</label>
											<span className="clearfix input-active">
												<input value={result.datos.negocioOperable} disabled  className="col-xs-1" >
													
												</input>
											</span>
										</div>
									</div>
								)}
								<div className="row card" style={{ maxWidth:400,  margin: "20px auto"}}>
									{result.inicioPoliza && (

										<div className="input-wrap no-margin">
											<label>Inicio Póliza</label>
											<span className="clearfix input-active">
												<input value={result.inicioPoliza} disabled  className="col-xs-1" >
													
												</input>
											</span>
										</div>
									)}
									{result.terminoPoliza && (
										<div className="input-wrap no-margin">
											<label>Fin Póliza</label>
											<span className="clearfix input-active">
												<input value={result.terminoPoliza} disabled  className="col-xs-1" >
													
												</input>
											</span>
										</div>
									)}
									{result.startDate && (
										<div className="input-wrap no-margin">
											<label>Fecha de registro</label>
											<span className="clearfix input-active">
												<input value={result.startDate.split(" ")[0]} disabled  className="col-xs-1" >
													
												</input>
											</span>
										</div>
									)}
								</div>
								{result.candidate && (
									<div>
										<div className="row card" style={{ maxWidth:400,  margin: "20px auto"}}>
											<div className="col-xs-6" >
											
												<div>
													<div className="col-xs-12" style={{'paddingTop': '3%'}}>
														<div style={{'height': '90px'}} className="row">
															<img className=" " src={result.supIzq}  style={{ 'objectFit': 'contain', display:"inline-block",width:"90%", maxHeight:"90px"}}/>													
														</div>
													</div>
												</div>
												<div >											
													<div className="col-xs-12" style={{'paddingTop': '3%'}}>
														<div style={{'height': '90px'}} className="row">
															<img className=" " src={result.supDer} style={{ 'objectFit': 'contain', display:"inline-block",width:"90%",maxHeight:"90px"}}/>													
														</div>												
													</div>
												</div>
											</div>
											<div className="col-xs-6" >
												<div  style={{'paddingTop': '3%'}}>
													<div className="col-xs-12">
														<div style={{'height': '90px'}} className="row">
															<img className=" " src={result.infIzq} style={{ 'objectFit': 'contain', display:"inline-block",width:"90%",maxHeight:"90px"}}/>
														</div>											
													</div>
												</div>
												<div >
													<div className="col-xs-12" style={{'paddingTop': '3%'}}>
														<div style={{'height': '90px'}} className="row">													
															<img className=" " src={result.infDer}  style={{ 'objectFit': 'contain', display:"inline-block",width:"90%",maxHeight:"90px"}}/>
														</div>												
													</div>
												</div>
											</div>
										</div>
										<div className="row card " style={{marginTop:20,  maxWidth:400,  margin: "0 auto"}}>									
											<div className="col-xs-12">Número de serie de tu vehículo y Kilometraje Inicial: </div>			
											<div className="row">											
												<div className="col-xs-6" style={{'paddingTop': '3%', 'textAlign':"center"}}>
													<img className="" src={result.vin}  style={{'height': '90px', 'objectFit': 'contain'}}/>
												</div>
												<div className="col-xs-6" style={{'paddingTop': '3%', 'textAlign':"center"}}>
													<img className="" src={result.startPhoto} style={{'height': '90px', 'objectFit': 'contain'}}/>
												</div>
											</div>
											<div className="row" style={{"paddingTop": "10%", "textAlign":"center"}}>
												<div className="col-xs-6" style={{'paddingTop': '3%', 'textAlign':"center"}}>
												</div>
												<div className="col-xs-6" style={{'paddingTop': '3%', 'textAlign':"center"}}>
													<p style={{"padding": "6px 4px", "fontSize": "14px"}}>Kilometraje Inicial:</p>
													<input disabled value={String(result.startKm).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}  type="tel"  noValidate id="camera-start" style={{'text-align':'center', 'borderWidth': '0 0 2px', 'borderBottom': '1px solid black', 'marginLeft': '5%', 'width': '85%', 'color': 'rgb(0, 0, 0)', 'font-weight': 'bold'}} />												
												</div>
											</div>
										</div>
									</div>
								)}
							</div>
							
						)}
					</div>					
				)}
			</div>);
	}
	onChangeMultiple(tipo, ev) {
		const options = ev.target.options;
		const value = [];
		for (let i = 0, l = options.length; i < l; i++) {
			if (options[i].selected) {
				value.push(options[i].value);
			}
		}
		const newState = this.state.config;
		newState[tipo] = value;
		this.setState({config:newState});
	}
	onChangeBuscar(tipo, ev) {
		const re = /^[0-9\b]+$/;
		if (ev.target.value === '' || re.test(ev.target.value)) {
			const newState= {}
			newState[tipo] = ev.target.value;
			this.setState(newState);
		}
	}
	onChange(tipo, ev) {
		const newState= this.state.config;
		newState[tipo] = ev.target.value;
		this.setState({config:newState});
	}
	onChangeIndex(index, tipo, ev) {
		const newState = this.state.config;
		newState.productos[index][tipo] = ev.target.value;
		this.setState({config:newState});
	}
	save(){
		database.ref("config/kilometro0").update(this.state.config);
		alert("Datos guardados correctamente!");
	}	
	getEmptyProduct() {
		return {
			productoTecnico:"",
			productoComercial:"",
			negocioOperable:""
		};
	}
	add() {
		const {config} = this.state;
		config.productos.push(this.getEmptyProduct());
		this.setState({config});
	}
	remove(i) {
		const {config} = this.state;
		config.productos.splice(i, 1);
		this.setState({config});
	}
	selectTab(tab) {
		this.setState({tab});
	}
	search(){
		const {buscar, version} = this.state;
		if(buscar === "" || version ==="" ){
			return alert("El valor de la póliza y la versión son obligatorios.");
		}
		getClientInfo(buscar, version)
			.then((result)=> {				
				this.setState({
					result
				});
			});
	} 
	login() {
		var provider = new firebase.auth.GoogleAuthProvider();
		authentication.signInWithPopup(provider).then((result)=> {
			database.ref("config/kilometro0").on("value", (snapshot)=> {
				const config = snapshot.val();
				if(!config.productos || config.productos.length ==0) {
					config.productos = [this.getEmptyProduct()];
				}
				this.setState({
					config,
					show: true
				});
			});
		});
	}
	
}

export default AdminKM0;


// WEBPACK FOOTER //
// ./src/admin/km0/adminKm0.cmpt.js